<section class="tc-links" aria-labelledby="tc-links-heading">
  <h3 id="tc-links-heading" class="tc-links__title">{{ 'testCases.form.links.blockTitle' | translate }}</h3>

  @if (loading()) {
    <ul class="tc-links__list" aria-busy="true">
      @for (row of placeholderRows; track row) {
        <li class="tc-links__placeholder"></li>
      }
    </ul>
  } @else if (loadError()) {
    <p class="tc-links__hint tc-links__hint--error" role="alert">
      {{ 'testCases.form.links.loadError' | translate }}
    </p>
    <button type="button" class="tc-links__retry" data-testid="tf-verknuepfung-retry" (click)="reload()">
      {{ 'testCases.form.links.retry' | translate }}
    </button>
  } @else {
    <ul class="tc-links__list">
      @for (link of links(); track link.id) {
        @let meta = metaFor(link);
        @let error = rowError(link);
        @let label = link.type === 'REQUIREMENT' ? link.reference : link.displayLabel || link.reference;
        <li class="tc-links__item" [class.tc-links__item--error]="error" data-testid="tf-verknuepfung">
          <span
            class="tc-links__icon"
            [class.tc-links__icon--filled]="meta.filled"
            [style.--tc-link-color]="meta.color"
            aria-hidden="true"
          >
            @if (meta.icon.kind === 'app-icon') {
              <app-icon [name]="meta.icon.name" [size]="14" />
            } @else if (meta.icon.kind === 'fa') {
              <i [class]="meta.icon.cls"></i>
            } @else {
              <mat-icon>{{ meta.icon.name }}</mat-icon>
            }
          </span>
          <span class="tc-links__body">
            @if (externalUrl(link); as url) {
              <a
                class="tc-links__ref"
                [href]="url"
                target="_blank"
                rel="noopener noreferrer"
                [attr.aria-label]="primaryText(link) + ' — ' + ('testCases.form.links.openInNewTab' | translate)"
              >
                {{ primaryText(link) }}
              </a>
            } @else if (requirementRoute(link); as route) {
              <a class="tc-links__ref" [routerLink]="route">{{ primaryText(link) }}</a>
            } @else {
              <span class="tc-links__ref">{{ primaryText(link) }}</span>
            }
            <span class="tc-links__type">
              @if (error) {
                {{ 'testCases.form.links.rowError.' + error | translate }}
              } @else if (link.type === 'REQUIREMENT') {
                {{ sourceKey(link) | translate }}
                @if (link.requirementType) {
                  · {{ link.requirementType | requirementTypeLabel }}
                }
              } @else {
                {{ 'testCases.form.links.types.' + link.type | translate }}
              }
            </span>
          </span>
          @if (requirementRoute(link); as route) {
            <a
              class="tc-links__open"
              data-testid="tf-verknuepfung-oeffnen"
              [routerLink]="route"
              [title]="'testCases.form.links.openRequirement' | translate"
              [attr.aria-label]="'testCases.form.links.openRequirementAria' | translate: { key: link.reference }"
            >
              <mat-icon aria-hidden="true">chevron_right</mat-icon>
            </a>
          }
          @if (!readOnly()) {
            <button
              type="button"
              class="tc-links__remove"
              data-testid="tf-verknuepfung-entfernen"
              (click)="onRemove(link)"
              [title]="'testCases.form.links.remove' | translate"
              [attr.aria-label]="('testCases.form.links.removeAria' | translate) + ' ' + label"
            >
              <mat-icon aria-hidden="true">close</mat-icon>
            </button>
          }
        </li>
      } @empty {
        <li class="tc-links__empty">{{ 'testCases.form.links.empty' | translate }}</li>
      }
    </ul>

    @if (mutationError()) {
      <p class="tc-links__hint tc-links__hint--error" role="alert">
        {{ 'testCases.form.links.mutationError' | translate }}
      </p>
    }

    @if (!readOnly()) {
      <button type="button" class="tc-links__add" data-testid="tf-verknuepfung-hinzufuegen" (click)="requestAddModal()">
        <mat-icon aria-hidden="true">add</mat-icon>
        {{ 'testCases.form.links.addButton' | translate }}
      </button>
    }

    @if (hasPendingChanges()) {
      <p class="tc-links__hint">{{ 'testCases.form.links.draftHint' | translate }}</p>
    }
  }
</section>
